var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.$options.components.VTooltip,{tag:"component",attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"text-truncate",staticStyle:{"width":"auto"}},on),[_vm._t("default",[_vm._v(" "+_vm._s(_vm.props.content)+" ")])],2)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.props.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }